'use client';

import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { SessionContext } from '@benzinga/session-context';
import { DetailedQuote, QuotesManager, Security } from '@benzinga/quotes-manager';
import { safeUnwrapOrThrow } from '@benzinga/safe-await';

const FIVE_MINUTES = 5 * 60 * 1000;

export const DETAILED_QUOTE_QUERY_KEY = 'detailedQuote' as const;

export const useDetailedQuoteQuery = (symbol: Security) => {
  const session = useContext(SessionContext);

  return useQuery<DetailedQuote | null>({
    enabled: !!symbol,
    queryFn: async () => {
      const result = await session.getManager(QuotesManager).getDetailedQuotes([symbol]);

      // The manager answers with a map keyed by symbol. React Query rejects undefined as
      // data, so a symbol the response omits becomes null rather than a failed read.
      return safeUnwrapOrThrow(result)?.[symbol] ?? null;
    },
    queryKey: [DETAILED_QUOTE_QUERY_KEY, symbol],
    staleTime: FIVE_MINUTES,
  });
};
